function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { ChartArea } from '../';
import moment from 'moment';
import "./ChartAreaStacked.scss";

class ChartAreaStacked extends Component {
  render() {
    return React.createElement(ChartArea, this.props);
  }

}

_defineProperty(ChartAreaStacked, "defaultProps", {
  areaOpacity: 1,
  enableSlices: "x",
  yScale: {
    type: "linear",
    stacked: true
  }
});

export default ChartAreaStacked;